<template>
  <div class="row mb-5">
    <div class="row mb-4">
      <label for="email" class="col-md-1 col-form-label">Email</label>
      <div class="col-md-3">
        <input v-model="email" type="text" class="form-control" id="email" />
      </div>
      <div class="col-md-3">
      <button v-on:click="findUser()" type="button" class="btn btn-primary">Search</button>
    </div>
    </div>
    
  </div>
  <div>
    <span>{{message}}</span>
  </div>
  <div class="row" v-if="this.users.length > 0">
    <table class="table table-striped">
      <thead>
        <th>ID</th>
        <th>E-mail</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Phone</th>
        <th>Country</th>
        <th>Klaviyo</th>
        <th>Locked</th>
        <th>Actions</th>
        <th>Details</th>
      </thead>
      <tbody>
        <tr v-for="row in users" :key="row.id" style="line-height: 35px;">
          <td>{{ row.id }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.firstname }}</td>
          <td>{{ row.lastname }}</td>
          <td>{{ row.phone }}</td>
          <td>{{ row.country }}</td>
          <td>
            <a :href="`https://www.klaviyo.com/profile/${row.klaviyoProfileId}`" target="_blank">{{
              row.klaviyoProfileId
            }}</a>
          </td>
          <td><input class="form-check-input" type="checkbox" :checked="row.isLocked" disabled /></td>
          <td>
            <button
              class="btn btn-outline-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Change Email Address"
              v-on:click="loadEmailChange(row.id, row.email)"
            >
              <i class="bi bi-envelope-fill"></i>
            </button>
            &nbsp;
            <button
              class="btn btn-outline-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Unlock User"
              v-on:click="loadUserUnlock(row.id, row.email)"
            >
              <i class="bi bi-unlock-fill"></i>
            </button>
          </td>
          <td><a :href="`/admin/user/${row.id}/vehicles`" target="_blank">Details</a></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="modal fade"
    id="changeEmailModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="changeEmailModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="changeEmailModalLabel">Change Email</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row mb-3">
              <label for="inputEmail3" class="col-sm-3 col-form-label">Current Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="oldEmail" v-model="email" disabled />
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputPassword3" class="col-sm-3 col-form-label">New Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="newEmail" v-model="newEmail" />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="changeEmail()">Yes</button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="unlockUserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="unlockUserModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="unlockUserModalLabel">Unlock User</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure to unlock <strong>{{ email }}</strong
          >?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="unlockUser()">Yes</button>
        </div>
      </div>
    </div>
  </div>
  <div class="position-absolute top-1 end-0 toast-container" style="top: 80px">
    <div
      id="notificationToast"
      class="toast align-items-center text-white bg-success border-0"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">{{ message }}</div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';
let changeEmailModal;
let unlockUserModal;
let toast;
export default {
  name: 'Users',
  data() {
    return {
      email: '',
      userId: '',
      newEmail: '',
      message: '',
      users: []
    };
  },
  created() {},
  mounted() {
    changeEmailModal = new bootstrap.Modal(document.getElementById('changeEmailModal'), {
      keyboard: false
    });
    unlockUserModal = new bootstrap.Modal(document.getElementById('unlockUserModal'), {
      keyboard: false
    });
    toast = new bootstrap.Toast(document.getElementById('notificationToast'));
  },
  methods: {
    loadEmailChange(userId, email) {
      this.email = email;
      this.userId = userId;
      changeEmailModal.show();
    },
    loadUserUnlock(userId, email) {
      this.email = email;
      this.userId = userId;
      unlockUserModal.show();
    },

    findUser: async function () {
      if (this.email) {
        const results = await apiClient(`users`, HTTP_METHODS.GET, {}, {redirectOnUnauthorized: true}, {
          filter: {where:{email: this.email}}
        });
        if (results.status === HTTP_STATUS_CODES.SUCCESS) {
          this.users = results.data;
          this.message = '';
        }
        if(results.data.length === 0){
          this.message = `Unable to find user with ${this.email}.`
        }
      }
    },
    unlockUser: async function () {
      if (this.email) {
        const result = await apiClient(`users/${this.userId}/unlockuser`, HTTP_METHODS.POST, {
          email: this.email
        });
        if (result.status === HTTP_STATUS_CODES.NO_CONTENT) {
          unlockUserModal.hide();
          this.message = 'User has been locked successfully.';
          toast.show();
        }
      }
    },
    changeEmail: async function () {
      if (this.email && this.newEmail) {
        const result = await apiClient(`users/${this.userId}/changeemail`, HTTP_METHODS.POST, {
          oldEmail: this.email,
          newEmail: this.newEmail
        });
        if (result.status === HTTP_STATUS_CODES.NO_CONTENT) {
          changeEmailModal.hide();
          this.message = 'Email has been changed successfully.';
          toast.show();
        }
      }
    }
  }
};
</script>
